























import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  props: {
    country: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('results', ['getCheckType']),
    checkType () {
      const checkTypesMap = {
        person: this.$t('Persona'),
        vehicle: this.$t('Conductor & vehículo'),
        company: this.$t('Empresas')
      } as Record<string, string>

      return checkTypesMap[this.getCheckType]
    },
    formLink () {
      const locale = this.$i18n.locale

      if (locale === '') {
        return 'https://account.truora.com/account#/es/quiz'
      }

      return `https://account.truora.com/account#/${locale}/quiz`
    }
  }
})
